module.exports = __webpack_public_path__ + "static/media/coinbase.d8b08d57.png";